import { AppointmentForm } from '@devexpress/dx-react-scheduler-material-ui';

const Select = (props: any) => <AppointmentForm.Select {...props} />;

export default Select;
